import React, { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { FlaskConical, Copy, Check, ChevronDown } from "lucide-react";

function CopyButton({ text, label, testId }) {
  const [ok, setOk] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); } catch { window.prompt("Copia:", text); }
    setOk(true);
    setTimeout(() => setOk(false), 2500);
  };
  return (
    <button type="button" onClick={copy} className="inline-flex items-center gap-1.5 rounded-full border border-viola/25 px-3 py-1.5 text-xs font-semibold hover:border-fucsia hover:text-fucsia" data-testid={testId}>
      {ok ? <Check size={12} aria-hidden /> : <Copy size={12} aria-hidden />} {ok ? "Copiato" : label}
    </button>
  );
}

export function SostanzePanel({ refreshKey }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [term, setTerm] = useState("");
  useEffect(() => { http.get("/rete/sostanze-missing").then((r) => setData(r.data)).catch(() => {}); }, [refreshKey]);
  if (!data) return null;
  const { missing, total } = data;
  const answered = total - missing.length;
  const emails = [...new Set(missing.map((m) => (m.email || "").trim().toLowerCase()).filter(Boolean))];
  const updateLink = `${window.location.origin}/rete/iscriviti?modo=aggiorna`;
  const shown = missing.filter((m) => `${m.nome} ${m.cognome} ${m.email}`.toLowerCase().includes(term.toLowerCase()));
  const pct = total ? (answered > 0 ? Math.max(1, Math.round((answered / total) * 100)) : 0) : 0;

  return (
    <div className="rounded-2xl bg-giallo/15 border border-giallo/60 p-5" data-testid="sostanze-panel">
      <p className="font-display text-lg flex items-center gap-2"><FlaskConical size={18} aria-hidden /> Voce "Sostanze / Riduzione del danno"</p>
      <p className="mt-1 text-sm" data-testid="sostanze-summary">
        Hanno risposto <strong>{answered}</strong> su {total}. Mancano ancora <strong>{missing.length}</strong> persone.
      </p>
      <div className="mt-3 h-2 rounded-full bg-viola/10 overflow-hidden" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} aria-label="Percentuale di risposte sulla voce sostanze">
        <div className="h-full bg-fucsia" style={{ width: `${pct}%` }} />
      </div>
      <p className="mt-3 text-sm text-viola/75">Mandagli il link per aggiornare la scheda: copialo e incollalo in una mail scritta da te, mettendo gli indirizzi in Ccn (copia nascosta).</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <CopyButton text={updateLink} label="Copia link di aggiornamento" testId="sostanze-copy-link" />
        <CopyButton text={emails.join(", ")} label={`Copia le ${emails.length} email`} testId="sostanze-copy-emails" />
        <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} className="inline-flex items-center gap-1 rounded-full border border-viola/25 px-3 py-1.5 text-xs font-semibold" data-testid="sostanze-toggle-list">
          {open ? "Nascondi elenco" : "Vedi elenco"} <ChevronDown size={12} className={open ? "rotate-180" : ""} aria-hidden />
        </button>
      </div>
      {open && (
        <div className="mt-4">
          <input type="search" value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Cerca nome o email…" aria-label="Cerca nell'elenco"
            className="w-full sm:w-72 rounded-full border border-viola/20 bg-white px-4 py-2 text-sm" data-testid="sostanze-search" />
          <ul className="mt-3 max-h-80 overflow-y-auto divide-y divide-viola/10 rounded-xl bg-white/70 border border-viola/10" data-testid="sostanze-list">
            {shown.map((m) => (
              <li key={m.id} className="px-3 py-2 text-sm flex flex-wrap justify-between gap-2">
                <span><strong>{m.nome} {m.cognome}</strong> <span className="text-viola/60">· {m.qualifica}</span></span>
                <span className="text-viola/70 break-all">{m.email || "nessuna email"}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
